export default __webpack_public_path__ + "static/media/pdf-file-icon.ad876311.svg";